var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisconnected = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 26.458 26.458",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2631 0 0 1 -3.2708 -.26595)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.046,
    cy: 22.827,
    r: 2.341
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.2957,
    cy: 9.9073,
    r: 1.5278
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.21,
    y: 6.5057,
    width: 3.1483,
    height: 3.0696,
    rx: 0.060605,
    ry: 0.060605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.345,
    y: 4.68,
    width: 1.4073,
    height: 18.44,
    rx: 0.027091,
    ry: 0.36408
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.96747 0 0 .96747 .78192 .83494)",
    d: "m14.724 4.5411h-4.0658l2.0329-3.5211z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m16.745 8.9797v2.8863l-3.6079 3.6079-0.03436-0.05727",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.3229
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.2838 10.691v4.2837l3.6079 3.6079 0.03436-0.05727",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.3229
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisconnected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/disconnected.23880eca961128d2d68c65452487ef39.svg";